import { render, staticRenderFns } from "./Materiali.vue?vue&type=template&id=61cf2a06&scoped=true&"
import script from "./Materiali.vue?vue&type=script&lang=js&"
export * from "./Materiali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf2a06",
  null
  
)

export default component.exports